/**
 * API Clients Module Routes
 *
 * Route definitions for the API Clients module.
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/api-clients',
        component: ModuleLayout,
        meta: {
            moduleKey: 'settings.api_clients',
        },
        children: [
            {
                path: '',
                name: 'api-clients-list',
                component: () => import('./views/ApiClientList.vue'),
                meta: {
                    title: 'API Clients',
                },
            },
            {
                path: 'create',
                name: 'api-clients-create',
                component: () => import('./views/ApiClientCreate.vue'),
                meta: {
                    title: 'Create API Client',
                },
            },
        ],
    },
]

export default routes
